import { ProductType } from '@tink/core/src/types';
import { useProduct } from '../../../ApplicationProviders/ProductProvider/ProductProvider';
import { applicationParameters } from '../../../../utilities/application-parameters';
import { shouldSkipUserConfirmation } from '../../../../models/configuration';
import { useConfiguration } from '../../../ApplicationProviders/ConfigurationProvider/ConfigurationProvider';

export const useShouldShowUserHintId = () => {
  const { productType } = useProduct();
  const { data: configurationData } = useConfiguration();

  const isPermanentUser =
    productType === ProductType.CREDENTIALS ||
    (productType === ProductType.TRANSACTIONS && applicationParameters.get('authorizationCode')) ||
    (productType === ProductType.PRODUCTS && applicationParameters.get('authorizationCode'));

  if (isPermanentUser && !shouldSkipUserConfirmation(configurationData)) {
    return { shouldShowUserHintId: true };
  }

  return { shouldShowUserHintId: false };
};
